<template>
  <div>
    <v-sheet class="py-3 py-md-6" color="primary">
      <TitleWidget dark>
        {{ item.title || title }}
      </TitleWidget>
    </v-sheet>

    <LoadingWidget v-if="loading" />

    <v-container v-else class="pb-10 pb-md-13 pb-lg-16 item">
      <v-row v-if="item.img || item.text" justify="center" no-gutters>
        <v-col cols="12" md="9">
          <img
            v-if="item.img"
            @error="onError"
            class="d-block mt-6"
            loading="lazy"
            :src="files + item.img + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
            :alt="item.title"
            width="100%"
          />

          <div
            v-if="item.text"
            class="
              grey--text
              text--darken-2 text-subtitle-1
              font-weight-light
              mt-6 mt-md-8
              item-text
              ck-content
            "
          >
            <span class="font-secondary" v-html="item.text"></span>
          </div>
        </v-col>
      </v-row>

      <v-alert v-else class="mt-5" type="info">
        Nenhum conteúdo adicionado até o momento.
      </v-alert>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import DefaultImg from "../assets/img/default-img.png";

const _config = {
  mod: "legislation",
};

const _data = {
  title: "Legislação",
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
  },
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .finally(() => (this.loading = false));
  },
  components: {
    TitleWidget,
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-text {
    line-height: 1.6;
  }

  &-img {
    display: block;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
